import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@shared/shared-shadcn-ui';
import { type ComponentPropsWithoutRef, type FC } from 'react';

type Properties = {
  isOpen: boolean;
  onOpenChange: ComponentPropsWithoutRef<typeof Dialog>['onOpenChange'];
};

const FormErrorDialog: FC<Properties> = ({ isOpen, onOpenChange }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="bg-ogn-blue p-8 lg:p-12 max-w-[940px] w-[calc(100%-40px)] !rounded-[16px] border-0">
        <DialogHeader>
          <DialogTitle className="text-[32px] font-bold text-ogn-bright-yellow font-roboto-condensed lg:text-[40px] text-center">
            Error!
          </DialogTitle>
          <DialogDescription className="text-ogn-white text-[22px] lg:text-[28px] font-bold font-roboto-condensed  text-center pt-4">
            Something went wrong. Please try again later.
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export { FormErrorDialog };

